<template>
  <b-card no-body class="border-0 bg-aba-secondary-100">
    <template v-if="isActiveRegistration">
      <template v-if="isSuccessRegister">
        <b-card-body>
          <h5>Vielen Dank für Ihre Registrierung</h5>
          <p>
            Sie erhalten eine E-Mail, um Ihr Passwort einzugeben. Bitte überprüfen Sie auch Ihren Spam-Ordner. Sobald das Passwort festgelegt ist, können Sie sich erneut anmelden.
          </p>
          <p>Nach erfolgreicher Aktivierung können
            <a class="fw-bolder" href="#" @click.prevent="reloadTab">
              Sie sich hier anmelden
            </a>
          </p>
        </b-card-body>
      </template>
      <template v-else>
        <b-card-body>
          <b-card-title class="mb-3" title-tag="h5">
            {{ translations[13299] }}
          </b-card-title>
          <b-form @submit="onRegistration" class="mt-3">
            <b-alert :show="isErrorsRegister" variant="danger">
              <span v-if="isUsernameExist">{{ translations[232] }}</span>
              <span v-if="isEmailExist">{{ translations[10870] }}</span>
            </b-alert>
            <b-alert :show="isErrorsRegisterPassword" variant="danger">
              {{ translations[1283] }}
            </b-alert>
            <b-form-group
              class="mb-2"
              id="input-group-1"
              label-for="applicant-username"
            >
              <b-form-input
                size="lg"
                class="border-0"
                id="applicant-username"
                v-model="register.username"
                type="text"
                :placeholder="translations[227]"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="mb-2"
              id="input-group-2"
              label-for="applicant-email"
            >
              <b-form-input
                size="lg"
                class="border-0"
                id="applicant-email"
                v-model="register.email"
                type="email"
                placeholder="E-mail"
                required
              ></b-form-input>
            </b-form-group>
            <b-row align-v="center">
              <b-col cols="auto">
                <b-form-group
                  class="mb-2"
                  id="input-group-3"
                  label-for="applicant-checkbox"
                >
                  <b-form-checkbox id="applicant-checkbox" v-model="isRegisterCheckbox" name="check-button" switch>
                    <p v-html="translations[9634]" class="mb-0"></p>
                    <b>
                      <a href="#" v-b-modal.policy-modal class="text-decoration-underline">
                        {{ translations[12917] }}
                      </a>
                    </b>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12" class="ml-auto">
                <b-button type="submit" :disabled="!isRegisterCheckbox" variant="primary">
                  {{ translations[13732] }}
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
        <b-card-body>
          {{ translations[13733] }}
          <a href="#" @click.prevent="isActiveRegistration = !isActiveRegistration">
            {{ translations[13734] }}
          </a>
        </b-card-body>
      </template>
    </template>
    <template v-else-if="isActiveRecover">
      <b-card-body>
        <b-card-title class="mb-3" title-tag="h5">
          Passwort <span class="fw-bold">vergessen?</span>
        </b-card-title>
        <b-form @submit="onRecover" class="mt-3">
          <b-alert :show="isRecoverErrors" variant="danger">
            {{ translations[11849] }}
          </b-alert>
          <b-alert :show="isRecoverSuccess" variant="success">
            {{ translations[11850] }}
          </b-alert>
          <b-form-group
            class="mb-2"
            label-for="applicant-email"
          >
            <b-form-input
              size="lg"
              class="border-0"
              id="applicant-email"
              v-model="recover.email"
              type="email"
              placeholder="E-mail"
              required
            ></b-form-input>
          </b-form-group>
          <b-row align-v="center">
            <b-col cols="12">
              <b-button type="submit" variant="primary">
                {{ translations[722] }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-body>
        {{ translations[13733] }}
        <a href="#" @click.prevent="isActiveRecover = !isActiveRecover">
          {{ translations[13734] }}
        </a>
      </b-card-body>
    </template>
    <template v-else>
      <b-card-body>
        <b-card-title class="mb-3" title-tag="h5">
          {{ translations[13728] }}
        </b-card-title>
        <b-form @submit="onLogin" autocomplete="off">
          <b-alert :show="isErrors" variant="danger">
            {{ translations[2016] }}
          </b-alert>
          <b-form-group
            class="mb-2"
            id="input-group-1"
            label-for="applicant-username"
          >
            <b-form-input
              autocomplete="off"
              size="lg"
              class="border-0"
              id="applicant-username"
              v-model="login.username"
              type="text"
              :placeholder="translations[227]"
              :readonly="isReadonly"
              @focus="isReadonly = false"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="mb-2"
            id="input-group-2"
            label-for="applicant-password"
          >
            <b-form-input
              autocomplete="off"
              size="lg"
              class="border-0"
              id="applicant-password"
              v-model="login.password"
              type="password"
              :placeholder="translations[228]"
              required
              :readonly="isReadonly"
              @focus="isReadonly = false"
            ></b-form-input>
          </b-form-group>
          <b-row align-v="center">
            <b-col cols="auto">
              <b-button type="submit" variant="primary">{{ translations[13729] }}</b-button>
            </b-col>
            <b-col cols="auto" class="ml-auto">
              <p class="fs-6 m-0">
                <a href="#" @click.prevent="isActiveRecover = !isActiveRecover"> {{ translations[1005] }}</a>
              </p>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-body>
        {{ translations[13730] }}<br/>
        <a href="#" @click.prevent="isActiveRegistration = !isActiveRegistration">
          {{ translations[13731] }}
        </a>
      </b-card-body>
    </template>
  </b-card>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { passwordRecovery } from '@/api/Auth';

@Component
export default class AuthFormApplicant extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get sid() {
    return AppModule.sid;
  }

  get languageSid() {
    return AppModule.languageSid;
  }

  get lang() {
    return AppModule.language;
  }

  get isRedirectToCabinet() {
    return UserModule.isRedirectToCabinet;
  }

  // TokenApplicant
  get accessTokenApplicant() {
    return UserModule.accessTokenApplicant;
  }

  // TokenConsultant
  get accessTokenConsultant() {
    return UserModule.accessTokenConsultant;
  }

  // TokenConsultant
  get accessTokenCompany() {
    return UserModule.accessTokenCompany;
  }

  isRegisterCheckbox = false;

  isReadonly = true;

  isActiveRecover = false;

  isErrors = false;

  isErrorsRegister = false;

  isErrorsRegisterPassword = false;

  isSuccessRegister = false;

  isEmailExist = false;

  isUsernameExist = false;

  isRecoverSuccess = false;

  isRecoverErrors = false;

  login = {
    username: '',
    password: '',
    sid: this.sid,
  };

  register = {
    username: '',
    // password: '',
    // password_repeat: '',
    email: '',
    sid: this.sid,
    lang: this.lang,
  };

  recover = {
    email: '',
    sid: this.sid,
  }

  get isActiveRegistration() {
    return AppModule.isRegistrationTab;
  }

  set isActiveRegistration(value: boolean) {
    AppModule.SET_REGISTRATION_TAB(value);
  }

  reloadTab() {
    this.isActiveRegistration = false;
    this.isSuccessRegister = false;
  }

  async onLogin(evt: { preventDefault: () => void }) {
    evt.preventDefault();
    try {
      this.isErrors = false;
      await UserModule.LoginApplicant(this.login).catch(() => {
        this.isErrors = true;
      });

      this.login.username = '';
      this.login.password = '';

      if (this.accessTokenConsultant) {
        UserModule.LogOutConsultant(this.sid);
      }

      if (this.accessTokenCompany) {
        UserModule.LogOutCompany(this.sid);
      }

      if (this.isRedirectToCabinet) {
        await this.$router.push({ name: 'Cabinet', query: { lang: AppModule.language } });
      } else {
        this.$bvModal.hide('authorization-modal');
      }
    } catch (error: any) {
      this.$bvToast.toast(error.response.data.message, {
        title: 'Warning',
        variant: 'warning',
        autoHideDelay: 5000,
        solid: true,
      });
    }
  }

  async onRegistration(evt: { preventDefault: () => void }) {
    evt.preventDefault();
    this.isEmailExist = false;
    this.isUsernameExist = false;
    this.isErrorsRegister = false;
    this.isErrorsRegisterPassword = false;
    try {
      await UserModule.RegisterApplicant(this.register);
      this.isSuccessRegister = true;
    } catch (error: any) {
      this.isErrorsRegister = true;
      if (error.response.data.message === 'email already exists') this.isEmailExist = true;
      if (error.response.data.message === 'username already exists') this.isUsernameExist = true;
      this.$bvToast.toast(error.response.data.message, {
        title: 'Warning',
        variant: 'warning',
        autoHideDelay: 5000,
        solid: true,
      });
    }
  }

  async onRecover(evt: { preventDefault: () => void }) {
    evt.preventDefault();
    try {
      this.isRecoverErrors = false;
      this.isRecoverSuccess = false;
      await passwordRecovery(this.recover).then(() => {
        this.isRecoverSuccess = true;
      });

      this.recover.email = '';
    } catch (error: any) {
      this.isRecoverErrors = true;
      this.$bvToast.toast(error.response.data.message, {
        title: 'Warning',
        variant: 'warning',
        autoHideDelay: 5000,
        solid: true,
      });
    }
  }
}
</script>
